
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14","viewBox":"0 0 14 14"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7 .282a5.249 5.249 0 00-5.26 5.224 5.154 5.154 0 001.049 3.132l3.887 5.2c.01.013.025.017.035.029a.393.393 0 00.613-.029c1.119-1.483 3.171-4.253 3.96-5.3v-.006a5.163 5.163 0 00.971-3.025A5.249 5.249 0 007 .282zm0 8.043a2.819 2.819 0 112.84-2.819A2.836 2.836 0 017 8.325z","fill":"#f29030"}})])
          )
        }
      }
    